import { Close as CloseIcon } from "@mui/icons-material";
import {
  IconButton,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";
import { useField } from "formik";
import React from "react";

interface Props
  extends Omit<
    MuiTextFieldProps,
    "value" | "onChange" | "onBlur" | "error" | "helperText" | "component"
  > {
  name: string;
  clearable?: boolean;
  helperText?: React.ReactNode;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
}

export const TextField = ({
  clearable,
  InputProps,
  helperText,
  value: valueProp,
  onChange: onChangeProp,
  ...props
}: Props) => {
  const [{ value, onChange, onBlur }, { touched, error }, { setValue }] =
    useField(props.name);
  return (
    <MuiTextField
      value={valueProp ?? value ?? ""} // should not be null, otherwise changing from controlled to uncontrolled
      onChange={onChangeProp ?? onChange}
      onBlur={onBlur}
      error={touched && Boolean(error)}
      helperText={(touched && error) || helperText}
      {...props}
      slotProps={{
        input: clearable
          ? {
              sx: {
                "&.MuiInputBase-adornedEnd:hover .clear-adornment": {
                  visibility: value ? "visible" : "hidden",
                },
              },
              endAdornment: (
                <IconButton
                  className="clear-adornment"
                  size="small"
                  color={"default"}
                  onClick={() => {
                    setValue("");
                  }}
                  aria-label="Clear"
                  sx={{ visibility: "hidden" }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
              ...InputProps,
            }
          : InputProps,
      }}
    />
  );
};
